import { httpRequest, request } from '../request';

import type { ApiParamsDefinition } from '../types/api-definition';
import type { ProductsListResponse } from '../types/product';

/**
 * 商品列表请求参数类型
 * 基于 API 定义，但扩展了：
 * 1. pc_product_number_lines_page 字段（前端特有）
 * 2. filter 字段支持前端使用的字段别名和类型
 */
export type ProductsListParams = ApiParamsDefinition['POST:/api/products/list']['data'] & {
  is_list_page?: boolean;
  pc_product_number_lines_page?: number;
};
const list = {
  list: (data: ProductsListParams, config = {}): Promise<ProductsListResponse> => {
    return httpRequest(
      'POST:/api/products/list',
      { data } as ApiParamsDefinition['POST:/api/products/list'],
      config,
    );
  },
  filter: (data: any) => request('/api/products/params', 'get', data),
  search: (data: any) => request('/api/products/search', 'get', data),
};

export default list;
